import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import 'handsontable/dist/handsontable.full.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    options: {
      customProperties: true
    }
  }
})
